import styled, { createGlobalStyle } from 'styled-components'
import { MEDIA } from '../../utils/constants'

const { MOBILE, MOBILE_UP } = MEDIA

export const Area = styled.div`
  padding: 16px;
  background-color: ${props => props.background};
`

export const Container = styled(Area)`
  margin: 0 auto;
  max-width: ${props => props.maxWidth || '540px'};
`

export const Title = styled.h1`
  font-size: 24px;
  font-family: var(--primary-font);
  margin: 0;
  font-weight: bold;
  padding: 0;
  text-align: center;
`

export const Subtitle = styled.p`
  color: var(--gray-3);
  font-weight: 300;
  font-size: 16px;
  font-family: var(--primary-font);
  line-height: 1.7rem;
  ${props => props.centered && 'text-align: center;'}

  a {
    color: var(--cobasi-blue);
    text-decoration: none;
  }
`

export const Backdrop = styled.span`
  display: ${props => props.visible ? 'block' : 'none'};
  content: '';
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1072;
`

export const BodyScrollLock = createGlobalStyle`
  body {
    overflow-y: ${props => props.active ? 'hidden' : 'auto'};
    overflow-x: hidden;
  }
`

export const DesktopOnly = styled.div`
  @media screen and ${MOBILE} {
    display: none !important;
  }
`

export const MobileOnly = styled.div`
  @media screen and ${MOBILE_UP} {
    display: none !important;
  }
`

export const IncompleteDataMessage = styled.div`
  background: var(--cobasi-orange);
  text-align: center;
  padding: 9px;
  font-size: 14px;
  font-family: var(--primary-font);
  font-weight: 600;
  color: var(--the-white);
`

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.12s ease-in;
  transform: ${props => props.visible ? 'translate(-50%, -50%)' : 'translate(-50%, -65%)'};
  opacity: ${props => props.visible ? 1 : 0};
  z-index: ${props => props.visible ? 1073 : -100};
  max-height: 100vh;
  width: 100vw;
  height: ${({ height }) => height ?? '100vh'};
  @supports (-webkit-touch-callout: none) {
    max-height: -webkit-fill-available;
  }
`

export const Modal = styled.div`
  overflow: auto;
  background-color: var(--the-white);
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;

  @media screen and ${MEDIA.MOBILE_UP} {
    padding-bottom: 30px;
    min-width: 721px;
    min-height: ${props => props.maxHeight || '515px'};
    max-width: min(721px, 90vw);
    max-height: 90vh;
    height: unset;
    width: unset;
    border-radius: 9px;
  }
`

export const ModalHeader = styled.div`
  height: 50px;
  min-height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  padding: 0 5px;

  @media screen and ${MEDIA.MOBILE_UP} {
    height: 35px;
    min-height: 35px;
  }
`

export const ModalContent = styled.div`
  overflow: auto;
  width: 100%;
  padding: 0 20px;

  @media screen and ${MEDIA.MOBILE_UP} {
    max-height: 100vh;
  }
`

export const ModalContentInner = styled.div`
  width: 100%;
  ${props => props.height && `height: ${props.height};`}

  @media screen and ${MEDIA.MOBILE_UP} {
    max-width: 352px;
    margin: 0 auto;
  }
`

export const ModalTitle = styled.h1`
  display: flex;
  align-items: center;
  font-family: var(--primary-font);
  font-size: 20px;
  font-weight: bold;
  color: white;
  max-width: 259px;
  text-align: center;
  line-height: 22px;
  flex-grow: 1;

  @media screen and ${MEDIA.MOBILE_UP} {
    font-size: 30px;
    max-width: 486px;
    line-height: 35px;
  }
`

export const CloseButton = styled.div`
  width: 39px;
  height: 39px;
  font-size: 39px;
  line-height: 34px;
  text-align: center;
  font-family: var(--primary-font);
  font-weight: 800;
  color: var(--cobasi-blue-light-4);
  cursor: pointer;

  @media screen and ${MEDIA.MOBILE_UP} {
    right: 7px;
    width: 22px;
    height: 22px;
    font: Bold 25px/21px var(--primary-font);
  }
`
export const WithBorder = styled.div`
  @media screen and ${MEDIA.MOBILE} {
    border: ${props => props.size} solid ${props => props.color};
    border-radius: ${props => props.radius};
  }
`
